<!-- src/views/StepperView.vue -->
<template>
  <div class="stepper-view">
    <!-- Header Component -->
    <Header />

    <!-- Main Content Area -->
    <main class="main-content">
      <Stepper />
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Stepper from '@/components/Stepper/Stepper.vue';

export default {
  name: 'StepperView',
  components: {
    Header,
    Stepper,
  },
};
</script>

<style scoped>
.stepper-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #ffffff;
}

.main-content {
  flex: 1;
  padding-top: 100px; /* Raum für den Fixed Header */
  width: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #f2f5e7 100%);
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 80px;
  }
}
</style>